<h4 id="paymentSummaryHeaderLabel">
  {{ 'ARC_PAYMENT_DOCUMENTS' | translate }}
</h4>
<div>
  <div *ngIf="!hasMultipleTransactions; else transactionsAndDocuments">
    <!-- keep in sync with transactionsAndDocuments below -->
    <shared-document-table-component
      id="singleTransactionDocumentTable"
      [modifiedDocuments]="modifiedDocuments"
      [isReadOnly]="true"
      [excludedColumns]="excludedDocumentTableCols"
      [hasMultipleTransactions]="hasMultipleTransactions"
    ></shared-document-table-component>
  </div>
  <ng-template #transactionsAndDocuments>
    <aur-tab-view>
      <aur-tab-panel label="{{ 'ARC_PAYMENT_TRANSACTIONS' | translate }}">
        <payment-transactions-table
          [isSurchargeFeeVisible]="isSurchargeFeeVisible"
          [excludedColumns]="excludedTransactionTableCols"
          [transactions]="transactions"
        ></payment-transactions-table>
      </aur-tab-panel>
      <aur-tab-panel label="{{ 'ARC_PAYMENT_DOCUMENTS' | translate }}">
        <shared-document-table-component
          id="multipleTransactionsDocumentTable"
          [modifiedDocuments]="modifiedDocuments"
          [isReadOnly]="true"
          [excludedColumns]="excludedDocumentTableCols"
          [hasMultipleTransactions]="hasMultipleTransactions"
        ></shared-document-table-component>
      </aur-tab-panel>
    </aur-tab-view>
  </ng-template>
</div>
